import { render, staticRenderFns } from "./PublisherDetail.vue?vue&type=template&id=601cdba2&scoped=true&"
import script from "./PublisherDetail.vue?vue&type=script&lang=js&"
export * from "./PublisherDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDetail.vue?vue&type=style&index=0&id=601cdba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601cdba2",
  null
  
)

export default component.exports